/**
 * Lida com a transferência de tokens JWT entre subdomínios após seleção de clínica.
 * O localStorage é por-origem (clinica-a.dominio ≠ clinica-b.dominio), então os tokens
 * são passados via URL fragment (#_t=...) e armazenados no novo subdomínio.
 */
export default defineNuxtPlugin(async () => {
  if (typeof window === 'undefined') return;

  const hash = window.location.hash;
  if (!hash.startsWith('#_t=')) return;

  try {
    const encoded = hash.slice(4);
    const { a: access, r: refresh } = JSON.parse(atob(encoded));
    if (!access || !refresh) return;

    const auth = useAuthStore();
    auth.setTokens({ access, refresh });

    // Busca dados do usuário já que o store está vazio no novo subdomínio
    const api = useApi();
    try {
      const { data } = await api.get('/auth/me');
      if (data?.data) {
        auth.user = data.data;
        auth._saveUser();
      }
    } catch { /* token inválido ou expirado */ }
  } catch { /* fragment inválido */ } finally {
    // Remove o fragment da URL para não vazar tokens no histórico
    history.replaceState(null, '', window.location.pathname + window.location.search);
  }
});
